import { get, post, BaseUrl } from './api'

/**
 * Get companies for the current user (for the select-company flow). Excludes rejected.
 * @returns {Promise.<{customerId:string,name:string,orgNumber:string,activationStatus:number}[]>}
 */
export const getCompaniesForMe = async () => {
  const list = await get('api/Customer/MyCompanies', BaseUrl.Centerpoint);
  return Array.isArray(list) ? list : [];
}

/**
 * Set selected company in Keycloak. Caller should then refresh the token and redirect.
 */
export const setCompany = async (customerId) => {
  return await post('api/me/company', { customerId }, null, BaseUrl.Centerpoint);
}
